import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage,transformResponse } from "./baseQuery";

export const UserApiSlice = createApi({
  reducerPath: "UserApiSlice",
  baseQuery,

  tagTypes: ["users", "userProfile"],

  endpoints: (builder) => ({
    // Get all users (admin only)
    getAllUsersApi: builder.query({
      query: (params) => ({
        url: "api/users/getAllUsers",
        method: "GET",
        params: params,
      }),
      transformResponse,
      transformErrorResponse: transformErrorResponseWithMessage,
      providesTags: ["users"]
    }),

    // Get user by ID
    getUserByIdApi: builder.query({
      query: (userId) => ({
        url: `api/users/getUser/${userId}`,
        method: "GET",
      }),
      transformResponse,
      transformErrorResponse: transformErrorResponseWithMessage,
      providesTags: ["userProfile"]
    }),

    // Update user status
    updateUserStatusApi: builder.mutation({
      query: (values) => ({
        url: `api/users/updateStatus/${values.userId}`,
        method: "PUT",
        body: values,
      }),
      transformResponse,
      transformErrorResponse,
      invalidatesTags: ["users", "userProfile"],
    }),

    // Delete user
    deleteUserApi: builder.mutation({
      query: (userId) => ({
        url: `api/users/deleteUser/${userId}`,
        method: "DELETE",
      }),
      transformResponse,
      transformErrorResponse,
      invalidatesTags: ["users"],
    }),

    // Get user statistics
    getUserStatsApi: builder.query({
      query: () => ({
        url: "api/users/getUserStats",
        method: "GET",
      }),
      transformResponse,
      transformErrorResponse: transformErrorResponseWithMessage,
      providesTags: ["users"]
    }),
  }),
});

export const {
  useGetAllUsersApiQuery,
  useGetUserByIdApiQuery,
  useUpdateUserStatusApiMutation,
  useDeleteUserApiMutation,
  useGetUserStatsApiQuery,
} = UserApiSlice; 